import React, { useState } from "react";
import { useNavigate, Navigate, Link, useSearchParams } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function AdminLogin() {
  const { user, ready, login } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const back = searchParams.get("back") || "/admin";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  if (ready && user && user.email) return <Navigate to={back} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(email, password);
      navigate(back);
    } catch (ex) {
      setErr(ex.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="admin-login-page" className="section">
      <div className="max-w-[440px] mx-auto px-6 md:px-10">
        <Link to="/" className="overline editorial-link">← Back to site</Link>
        <div className="mt-10 overline">Institute admin</div>
        <h1 className="font-serif-editorial tight-track mt-4" style={{ fontSize: "clamp(2.4rem, 5vw, 3.5rem)", lineHeight: 1 }}>
          Sign in.
        </h1>
        <form onSubmit={submit} className="mt-10 space-y-5" data-testid="admin-login-form">
          <div>
            <label className="overline">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="login-email"
              className="mt-2 w-full px-4 py-3 border text-sm outline-none"
              style={{ borderColor: "rgba(79,87,70,0.4)", backgroundColor: "transparent" }}
            />
          </div>
          <div>
            <label className="overline">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="login-password"
              className="mt-2 w-full px-4 py-3 border text-sm outline-none"
              style={{ borderColor: "rgba(79,87,70,0.4)", backgroundColor: "transparent" }}
            />
          </div>
          {err && <div className="text-sm" style={{ color: "#8a3a3a" }} data-testid="login-error">{err}</div>}
          <button type="submit" disabled={loading} className="btn-olive w-full" data-testid="login-submit">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
